/**
 * @generated SignedSource<<e662db5156051e745fc55338b99980eb>>
 * @relayHash 34e0c09a47a465c4beae8fe001594b5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15ad5ee8e61447c764ac80e10cc756df9689df6c4dadb969daa52a50669e5642

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraUpdateVersionPositionInput = {
  afterVersionId: string;
  id: string;
};
export type table_updateJiraVersionPositionMutation$variables = {
  input: JiraUpdateVersionPositionInput;
};
export type table_updateJiraVersionPositionMutation$data = {
  readonly jira: {
    readonly updateJiraVersionPosition: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type table_updateJiraVersionPositionMutation = {
  response: table_updateJiraVersionPositionMutation$data;
  variables: table_updateJiraVersionPositionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraUpdateVersionPayload",
        "kind": "LinkedField",
        "name": "updateJiraVersionPosition",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "table_updateJiraVersionPositionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "table_updateJiraVersionPositionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "15ad5ee8e61447c764ac80e10cc756df9689df6c4dadb969daa52a50669e5642",
    "metadata": {},
    "name": "table_updateJiraVersionPositionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "28f8db8e730d8adacf8286693c281f13";

export default node;
